export const faqList = [
  {
    question: 'hth平台如何保障商品正品？',
    answer: 'hth建立了严格的供应链管理体系，从商品源头审核、入库质检到出库复核，每个环节都经过多层验证。我们引入区块链溯源技术，为每件商品赋予唯一数字身份，用户可扫码查看全流程信息。如发现非正品，hth承诺无条件退款并额外赔偿。',
  },
  {
    question: '如何注册成为hth会员？',
    answer: '访问hth官网，点击右上角"立即注册"按钮，使用手机号码或邮箱即可快速注册。注册后建议完成实名认证，以享受完整会员权益。注册过程仅需1-2分钟。',
  },
  {
    question: 'hth会员有哪些等级？如何升级？',
    answer: 'hth会员分为青铜、白银、黄金、钻石四个等级。通过消费累计积分可逐步提升等级，不同等级享有不同的权益。青铜为注册即享，升级到白银需累计消费满一定额度，具体标准可在会员中心查看。',
  },
  {
    question: 'hth的极速服务响应时间是多少？',
    answer: 'hth提供7x24小时全天候服务。在线客服平均响应时间不超过30秒，电话客服在工作时间内即时接听。黄金及以上会员享有专属管家服务，优先处理各类问题。',
  },
  {
    question: '如何联系hth客服？',
    answer: '您可以通过以下方式联系hth客服：1）平台在线客服（7×24小时在线）；2）客服热线：400-XXX-XXXX（工作日9:00-18:00）；3）客服邮箱：support@hth-platform.com；4）微信公众号：hth官方平台。',
  },
  {
    question: '会员积分会过期吗？如何查看积分？',
    answer: 'hth会员积分有效期为获得之日起12个月，到期未使用的积分将自动清零。您可以在"会员中心 - 我的积分"页面查看积分余额与明细，也可以通过APP随时查询。',
  },
  {
    question: 'hth支持哪些支付方式？',
    answer: 'hth平台支持多种支付方式，包括微信支付、支付宝、银行卡支付等主流支付渠道。所有支付均经过严格加密，确保您的资金安全。',
  },
  {
    question: '如何申请退换货？',
    answer: '如您对商品不满意，可在收到商品后7天内申请退换货。在"我的订单"中找到对应订单，点击"申请退换货"并填写原因即可。客服将在24小时内审核处理。',
  },
];

export const advantages = [
  {
    icon: 'ri-shield-check-line',
    title: '正品保障',
    description: '严格供应链管理，区块链溯源技术，100%正品承诺，假一赔十。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速响应',
    description: '7×24小时全天候服务，30秒内响应，30分钟问题解决，高效便捷。',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '会员权益',
    description: '四大等级体系，丰富专属权益，积分累计兑换，生日专属礼遇。',
  },
  {
    icon: 'ri-global-line',
    title: '全球配送',
    description: '覆盖全国的物流网络，国际配送服务，快速安全，全程可追踪。',
  },
  {
    icon: 'ri-lock-line',
    title: '安全可靠',
    description: '银行级数据加密，多重风控体系，用户隐私保护，交易安全无忧。',
  },
  {
    icon: 'ri-heart-line',
    title: '贴心服务',
    description: '专属管家一对一服务，个性化推荐，售后无忧，用心对待每一位用户。',
  },
];

export const stats = [
  { value: '1000万+', label: '累计注册用户' },
  { value: '99.99%', label: '正品率' },
  { value: '30秒', label: '平均客服响应' },
  { value: '300+', label: '覆盖城市' },
];

export const membershipTiers = [
  {
    name: '青铜会员',
    icon: 'ri-copper-coin-line',
    color: 'bg-secondary-500',
    textColor: 'text-secondary-700',
    bgColor: 'bg-secondary-50',
    borderColor: 'border-secondary-200',
    price: '免费注册',
    features: ['正品保障', '专属客服通道', '基础折扣优惠', '积分累计'],
  },
  {
    name: '白银会员',
    icon: 'ri-shield-star-line',
    color: 'bg-secondary-600',
    textColor: 'text-secondary-800',
    bgColor: 'bg-secondary-50',
    borderColor: 'border-secondary-300',
    price: '¥299/年',
    features: ['全部青铜权益', '优先发货', '双倍积分', '生日专属礼遇'],
  },
  {
    name: '黄金会员',
    icon: 'ri-vip-crown-2-line',
    color: 'bg-primary-500',
    textColor: 'text-primary-700',
    bgColor: 'bg-primary-50',
    borderColor: 'border-primary-300',
    price: '¥999/年',
    features: ['全部白银权益', '全场折扣', '专属管家服务', '免邮特权'],
    highlight: true,
  },
  {
    name: '钻石会员',
    icon: 'ri-vip-diamond-line',
    color: 'bg-accent-500',
    textColor: 'text-accent-700',
    bgColor: 'bg-accent-50',
    borderColor: 'border-accent-300',
    price: '¥2999/年',
    features: ['全部黄金权益', '私人定制服务', '全球配送', '年度尊享大礼'],
  },
];